export const WORKSPACE_KEY = ["WORKSPACES"];
